export default __webpack_public_path__ + "static/media/726.7efc8dba.png";